export default {
  title: {
    nl: 'High Scores'
  },

  week: {
    nl: 'Week'
  }
};
